module.exports = __webpack_public_path__ + "static/media/1.cd4921a9.svg";